import React, { useState } from 'react';
import './AdminView.css';
import RohlingVerwaltung from '../components/RohlingVerwaltung';
import HolzAnhaengerVerwaltung from '../components/HolzAnhaengerVerwaltung';
import GravurfarbenverwaltungComponent from '../components/GravurfarbenverwaltungComponent';
import RohlingfarbenVerwaltung from '../components/RohlingfarbenVerwaltung';
import SchriftartenVerwaltung from '../components/SchriftartenVerwaltung';
import BilderVerwaltung from '../components/BilderVerwaltung';
import EmailConfig from '../components/EmailConfig';

function AdminView() {
  const [activeTab, setActiveTab] = useState('rohlinge');

  return (
    <div className="container admin-view">
      <h1 className="page-title">Admin-Bereich</h1>

      <div className="tabs">
        <button
          className={`tab ${activeTab === 'rohlinge' ? 'active' : ''}`}
          onClick={() => setActiveTab('rohlinge')}
        >
          Dog-Tags verwalten
        </button>
        <button
          className={`tab ${activeTab === 'allgemein' ? 'active' : ''}`}
          onClick={() => setActiveTab('allgemein')}
        >
          Allgemeine Einstellungen
        </button>
        <button
          className={`tab ${activeTab === 'holz' ? 'active' : ''}`}
          onClick={() => setActiveTab('holz')}
        >
          Christbaumanhänger Holz verwalten
        </button>
        <button
          className={`tab ${activeTab === 'bilder' ? 'active' : ''}`}
          onClick={() => setActiveTab('bilder')}
        >
          Bilder verwalten
        </button>
        <button
          className={`tab ${activeTab === 'schriftarten' ? 'active' : ''}`}
          onClick={() => setActiveTab('schriftarten')}
        >
          Schriftarten verwalten
        </button>
        <button
          className={`tab ${activeTab === 'email' ? 'active' : ''}`}
          onClick={() => setActiveTab('email')}
        >
          E-Mail-Konfiguration
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'rohlinge' && <RohlingVerwaltung />}
        {activeTab === 'holz' && <HolzAnhaengerVerwaltung />}
        {activeTab === 'allgemein' && (
          <div className="general-settings-grid">
            <div className="card">
              <GravurfarbenverwaltungComponent />
            </div>
            <div className="card">
              <RohlingfarbenVerwaltung />
            </div>
            <div className="card">
              <BilderVerwaltung />
            </div>
            <div className="card">
              <SchriftartenVerwaltung />
            </div>
            <div className="card">
              <EmailConfig />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminView;
